export const pagination = (nb: number = 0, divide: number = 6) => {
  const pageNb = Math.ceil(nb / divide);
  return pageNb === 0 ? 1 : pageNb;
};
